import { useEffect } from 'react'

import { BannerActionLarge } from '@loadsmart/loadsmart-ui'

import { Icon } from 'core/ui/components/icon/Icon'

import { analytics } from 'legacy/utils/analytics'

import { type PreferredLane } from '../domain/PreferredLane'
import { type SuggestedPreferredLaneAction } from '../domain/SuggestedPreferredLane'
import { formatTitle } from '../presenters/PreferredLanePresenter'

type SuggestPreferredLaneBannerProps = {
  preferredLane: PreferredLane
  action: SuggestedPreferredLaneAction
  primaryAction?: string
  secondaryAction?: string
  onClose: () => void
  onAdd: () => void
}

export function SuggestPreferredLaneBanner({
  preferredLane,
  onClose,
  onAdd,
  primaryAction,
  secondaryAction,
  action,
}: SuggestPreferredLaneBannerProps) {
  const title = formatTitle(preferredLane)

  useEffect(
    function onMount() {
      analytics.track('Preferred Lane Suggestion / View', {
        lane: preferredLane,
        action,
      })
    },
    [preferredLane, action]
  )

  return (
    <BannerActionLarge
      icon={<Icon name="markers-favorite" size={24} />}
      title={title}
      description={`Do you run this lane often? Save it as a preferred lane so you can be notified when we have a load for you.`}
      variant="success"
      action={primaryAction || 'Save as preferred lane'}
      onActionButtonClick={onAdd}
      secondaryAction={secondaryAction || 'Close'}
      onSecondaryActionButtonClick={onClose}
      onClose={onClose}
      dismissible
    />
  )
}
